export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const validatePasswords = (password: string, confirmPassword: string): { isValid: boolean, errorKey: string } => {
  if (password !== confirmPassword) {
    return { isValid: false, errorKey: "auth.resetPassword.errors.passwordsDontMatch" };
  }
  return { isValid: true, errorKey: "" };
};

export const validateEmail = (email: string): boolean => {
  return emailRegex.test(email);
};
